import { useState } from "react";
import {
  Button,
  TextField,
  Modal,
  Typography,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
// import { Link } from "react-router-dom";
import axios from "../api/axios";
import PackageTrackingStepper from "./PackingTrackingStepper";

const TrackingForm = () => {
  const [trackingNumber, setTrackingNumber] = useState("");
  const [error, setError] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [trackingResult, setTrackingResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [apiError, setApiError] = useState("");

  const handleInputChange = (e) => {
    setTrackingNumber(e.target.value);
    setError("");
    setApiError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Basic validation
    if (!trackingNumber) {
      setError("Tracking code must be provided.");
      return;
    }
    if (trackingNumber.length !== 15) {
      setError("Invalid tracking code. Must be exactly 15 characters.");
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post("track-package", {
        trackingCode: trackingNumber,
      });

      if (response.status === 200 && response.data?.foundTrackedPackage) {
        setTrackingResult(response?.data?.foundTrackedPackage);
        setOpenModal(true);
      } else {
        setApiError("Tracking information not found.");
      }
    } catch (error) {
      console.error(error);
      setApiError("An error occurred while fetching tracking data.");
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setOpenModal(false);
    setTrackingNumber("");
    setTrackingResult(null);
    setError("");
    setApiError("");
  };

  console.log({ trackingResult });

  return (
    <div className="min-w-auto   mx-auto flex justify-center   items-center ">
      <form
        onSubmit={handleSubmit}
        className=" min-w-[90%]     py-8 px-[1] lg:py-0 rounded-lg space-y-1 mx-auto flex flex-col justify-center items-center  "
      >
        <Typography
          sx={{
            width: "100%",
            // bgcolor: "green",
            color: "white",
            fontWeight: 1800,
            fontSize: { xs: "1.7rem", sm: "3rem" },
            letterSpacing: { lg: "-0.2rem" },
            ml: { lg: "0" },
            textAlign: { xs: "center", lg: "left" },
          }}
        >
          <span className=" font-poppin  text-center    text-nowrap  font-[900]  tracking-wide">
            Track Your Package
          </span>
        </Typography>
        <TextField
          label="Tracking Number"
          value={trackingNumber}
          onChange={handleInputChange}
          fullWidth
          margin="normal"
          error={!!error}
          helperText={error || apiError}
          disabled={loading}
          sx={{
            ml: { lg: "0" },
            borderRadius: { xs: "0.8rem", xl: "2rem" },
            minWidth: { xs: "100%", lg: "20rem", xl: "45rem" },
            "& .MuiOutlinedInput-root": {
              borderRadius: { xs: "0.8rem", xl: "2rem" },
              overflow: "hidden",
              height: { xs: "3rem", xl: "4rem" },

              bgcolor: "#edede9",

              px: "1rem",
            },
            "& .MuiInputBase-input": {
              color: "black",
              paddingY: "0.7rem",
            },
          }}
        />
        {/* <Button

				className="w-[8rem]  "
					type="submit"
					variant="contained"
					color="primary"
					disabled={loading}
					sx={{
						width: { xs: "8rem", lg: "15rem" },
						mx: { sm: "auto", lg: "0" },
						zIndex: 0,
						color: "#034052",
						bgcolor: "#f1c24e",
						fontSize: { sm: "1.2rem", md: "1.5rem" },
						borderRadius: "0.5rem",
						textTransform: "capitalize",
						position: "relative",
					}}>
					<span className="font-black">
						{loading ? <CircularProgress size={24} /> : "Track Now"}
					</span>
				</Button> */}
        <div className="  min-w-[50%]   flex flex-col  gap-[0.5rem]   mx-auto       md:mx-0  lg:mr-auto  justify-center         lg:gap-4  xl:gap-[2rem]   lg:pt-[0.5rem]    capitalize   text-center   items-center lg:items-start  font-black tracking-wide ">
          <button className=" w-[9rem]  bg-yellow-600  z-0  text-white  py-[0.2rem] border-2   lg:py-[0.5rem]  border-gray-400 px-2   rounded-lg  lg:rounded-full">
            {loading ? <CircularProgress size={24} /> : "Track Now"}
          </button>
          {/* <div className="flex flex-col gap-[0.5rem] lg:gap-[2rem]  lg:flex-row    ">
						<Link className="w-[9rem] py-[0.2rem] border-2 inline-block lg:py-[0.5rem]  border-gray-400 px-2 custom-yellow-text custom-blue-bg rounded-lg  lg:rounded-full">
							Ship Now
						</Link>
						<Link className="w-[9rem]   inline-block border-2 lg:py-[0.5rem]  border-gray-400 py-[0.2rem] px-2 custom-yellow-text custom-blue-bg rounded-lg  lg:rounded-full">
							Get a Quote
						</Link>
					</div> */}
        </div>
      </form>

      {/* Modal for displaying tracking result */}
      <Modal
        open={openModal}
        onClose={handleClose}
        className="flex items-center justify-center min-w-full min-h-full"
      >
        <div className="bg-white rounded-lg p-6 shadow-lg w-[90%] max-w-[600px] relative">
          <Button
            onClick={handleClose}
            sx={{ position: "absolute", top: 8, right: 8 }}
            size="small"
          >
            <CloseIcon />
          </Button>
          {trackingResult ? (
            <article className="overflow-y-auto flex flex-col    text-[0.9rem]   justify-start items-start max-h-[80vh]">
              {/* Delivery Details */}
              <div className="w-full mb-4">
                <h5 className="bg-blue-500 text-white    font-medium p-2">
                  Delivery Details
                </h5>
                <ul className="list-inside my-2 text-gray-700   ">
                  <li className="  py-[0.2rem]">
                    <span className="text-[0.8rem]  font-medium">
                      {" "}
                      Sender's Name:
                    </span>{" "}
                    <span className="text-gray-500"></span>{" "}
                    {trackingResult?.senderFullName || "N/A"}
                  </li>
                  <li className="border-y-2  border-y-gray-300  py-[0.2rem]">
                    <span className="text-[0.8rem]  font-medium">
                      {" "}
                      Sender's Email:
                    </span>{" "}
                    <span className="text-gray-500">
                      {" "}
                      {trackingResult?.senderEmail || "N/A"}
                    </span>
                  </li>
                  <li className="  py-[0.2rem]">
                    <span className="text-[0.8rem]  font-medium">
                      Recipient Name:
                    </span>{" "}
                    <span className="text-gray-500">
                      {" "}
                      {trackingResult?.recipientFullName || "N/A"}
                    </span>
                  </li>
                  <li className="border-y-2  border-y-gray-300  py-[0.2rem]">
                    <span className="text-[0.8rem]  font-medium">
                      {" "}
                      Recipient Email:
                    </span>{" "}
                    <span className="text-gray-500">
                      {" "}
                      {trackingResult?.recipientEmail || "N/A"}
                    </span>
                  </li>
                  <li className="  py-[0.2rem]">
                    <span className="text-[0.8rem]  font-medium">
                      {" "}
                      Recipient Country:
                    </span>{" "}
                    <span className="text-gray-500">
                      {" "}
                      {trackingResult?.toCountry || "N/A"}
                    </span>
                  </li>
                  <li className="border-y-2  border-y-gray-300  py-[0.2rem]">
                    {" "}
                    <span className="text-[0.8rem]  font-medium">
                      {" "}
                      Recipient City:
                    </span>{" "}
                    <span className="text-gray-500">
                      {trackingResult?.toCity || "N/A"}{" "}
                    </span>{" "}
                  </li>
                </ul>
              </div>

              {/* Package Details */}
              <div className="w-full mb-4">
                <h5 className="bg-blue-500 text-white font-medium p-2">
                  Package Details
                </h5>
                <ul className="list-inside my-2 text-gray-700">
                  <li className=" py-[0.2rem]">
                    <span className="text-[0.8rem]  font-medium">
                      Tracking Number:{" "}
                    </span>
                    <span className="text-gray-500">
                      {" "}
                      {trackingResult?.trackingNumber || "N/A"}
                    </span>
                  </li>
                  <li className="border-y-2  border-y-gray-300  py-[0.2rem]">
                    <span className="text-[0.8rem]  font-medium">
                      {" "}
                      Shipping Date:{" "}
                    </span>
                    <span className="text-gray-500">
                      {" "}
                      {trackingResult?.createdAt || "N/A"}
                    </span>
                  </li>
                  <li>
                    <span className="text-[0.8rem]  font-medium">
                      {" "}
                      Actual Delivery Date:{" "}
                    </span>
                    <span className="text-gray-500">
                      {" "}
                      {trackingResult?.estimatedDeliveryDate || "N/A"}
                    </span>
                  </li>
                  <li className="border-y-2  border-y-gray-300  py-[0.2rem]">
                    <span className="text-[0.8rem]  font-medium">
                      {" "}
                      Estimated Delivery Date:{" "}
                    </span>
                    <span className="text-gray-500">
                      {" "}
                      {trackingResult?.estimatedDeliveryDate || "N/A"}
                    </span>
                  </li>
                </ul>
              </div>

              {/* Shipment Status */}
              <div className="w-full mb-4">
                <h5 className="bg-blue-500 text-white font-medium p-2">
                  Shipment Status
                </h5>
                <ul className="list-inside my-2 text-gray-700">
                  <li className="  py-[0.2rem]">
                    <span className="text-[0.8rem]  font-medium">
                      {" "}
                      Current Status:
                    </span>{" "}
                    <span className="text-gray-500">
                      {" "}
                      {trackingResult?.shipmentStatus || "N/A"}
                    </span>
                  </li>
                  <li className="border-y-2  border-y-gray-300  py-[0.2rem]">
                    Date: {trackingResult?.updatedAt || "N/A"}
                  </li>
                </ul>
              </div>

              {/* Package Tracking History */}
              <div className="w-full mb-4">
                <h5 className="bg-blue-500 text-white font-medium p-2">
                  Package Tracking History
                </h5>
                <div className="overflow-y-auto max-h-[200px]">
                  <PackageTrackingStepper
                    steps={trackingResult.trackingHistory || []}
                  />
                </div>
              </div>
            </article>
          ) : (
            <Typography align="center" sx={{ p: 2 }}>
              No tracking data available.
            </Typography>
          )}
          <Button
            variant="contained"
            color="primary"
            onClick={handleClose}
            sx={{ mt: 2 }}
          >
            Close
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default TrackingForm;
